import { c as _c } from "react/compiler-runtime";
import { HandleSearchSubmitType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-panel.types";
import { CityDataType } from "@website/accommodation-ui/hotel-search/hotel-search.types";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import { daysBetweenDates } from "@website/utils/date-format";
import { useState } from "react";
const getDestinationLatitude = (destinationItem: any) => destinationItem?.lat ?? (Array.isArray(destinationItem?.location) ? destinationItem.location[0] : destinationItem?.location?.latitude) ?? destinationItem?.location?.lat;
const getDestinationLongitude = (destinationItem: any) => destinationItem?.long ?? destinationItem?.lng ?? (Array.isArray(destinationItem?.location) ? destinationItem.location[1] : destinationItem?.location?.longitude) ?? destinationItem?.location?.lon;
export const useSubmit = (selectedDestinationItem, date, passengerNumber, addToHistory, submitValidationCheck, handleSearchSubmit, initialDestinationItem, t0) => {
  const $ = _c(12);
  const requireDates = t0 === undefined ? true : t0;
  const [submitLoading, setSubmitLoading] = useState(false);
  let t1;
  if ($[0] !== addToHistory || $[1] !== date || $[2] !== handleSearchSubmit || $[3] !== initialDestinationItem || $[4] !== passengerNumber || $[5] !== requireDates || $[6] !== selectedDestinationItem || $[7] !== submitValidationCheck) {
    t1 = async () => {
      setSubmitLoading(true);
      if (submitValidationCheck()) {
        const startDate = date[0]?.dateTime || "";
        const endDate = date[1]?.dateTime || "";
        const hasDates = Boolean(startDate && endDate);
        const destinationItem = selectedDestinationItem || initialDestinationItem;
        if (destinationItem && (hasDates || !requireDates)) {
          if (hasDates) {
            addToHistory(destinationItem, startDate, endDate, passengerNumber);
          }
          await handleSearchSubmit?.(destinationItem.url || destinationItem?.title, startDate, endDate, `${passengerNumber.adult}`, `${passengerNumber.child}`, `${passengerNumber.room}`, destinationItem.type, destinationItem?.id, destinationItem?.title, getDestinationLatitude(destinationItem), getDestinationLongitude(destinationItem), destinationItem?.isHotel);
          if (hasDates) {
            const trackingPayload = {
              stay_duration_days: daysBetweenDates(startDate, endDate)
            };
            addEventToTracking(USER_TRACKING_EVENTS.DATE_SELECTED, {
              product: process.env.NEXT_PUBLIC_APP_NAME === "hotel-domestic" ? "dom-hotel" : process.env.NEXT_PUBLIC_APP_NAME as any,
              ...trackingPayload
            });
          }
          setSubmitLoading(false);
        } else {
          setSubmitLoading(false);
        }
      } else {
        setSubmitLoading(false);
      }
    };
    $[0] = addToHistory;
    $[1] = date;
    $[2] = handleSearchSubmit;
    $[3] = initialDestinationItem;
    $[4] = passengerNumber;
    $[5] = requireDates;
    $[6] = selectedDestinationItem;
    $[7] = submitValidationCheck;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const onSubmitClick = t1;
  let t2;
  if ($[9] !== onSubmitClick || $[10] !== submitLoading) {
    t2 = {
      onSubmitClick,
      submitLoading
    };
    $[9] = onSubmitClick;
    $[10] = submitLoading;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};